import { useEffect, useState } from 'react';

/** Router minimo su hash (#/t/<tenant>/<sezione>/<id>): sopravvive al refresh, nessuna dipendenza. */
export function useRoute(): string[] {
  const read = () => window.location.hash.replace(/^#\/?/, '').split('/').filter(Boolean);
  const [segments, setSegments] = useState(read);
  useEffect(() => {
    const onChange = () => setSegments(read());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return segments;
}

export const navigate = (path: string) => {
  window.location.hash = path.startsWith('/') ? path : `/${path}`;
};
